export class Settlement {
  constructor(
    public settlementId: string,
    public name: string,
    public id: string,
    public accountId: string,
    public partnerId: string,
    public partnerCode: string,
    public code: string,
    public hasSettlement: boolean,
    public address: string,
    public addressName: string,
    public networkId: string,
    public bankId: string,
    public bankName: string,
    public currencyId: string,
    public accountNumber: string,
    public date: string,
    public segmentTime: string,
    public settlementDate: string,
    public settlementReleaseDate: string,
    public total: string,
    public amount: string,
    public releaseAmount: string,
    public type: string,
    public settlementStatus: string,
  ) {}
}

export class SettlementDetail {
  constructor(
    public createdTime: Date | null,
    public updatedTime: Date | null,
    public transactionId: string,
    public settlementId: string,
    public accountId: string,
    public type: string,
    public amount: number,
    public settlementStatus: string,
    public releaseStatus: SettlementReleaseStatus,
  ) {}
}

export enum SettlementReleaseStatus {
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
  PROCESS = 'process',
}
